import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { ArtworkContainer } from '../artworkBoxes';
import { Icon } from '../icon/icon.component';
import { Markdown } from '../markdown/markdown.component';
import { ValidationBar } from '../validationBar/validationBar.component';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${Color.Gray300};
`;

export const Header: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0;

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PayButton: StyledComponent<'button'> = styled.button`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  margin-left: 24px;
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  margin-right: 10px;
`;

export const BadgesContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;

  @media ${Breakpoint.Mobile} {
    margin-bottom: 10px;
  }
`;

export const DateContainer: StyledComponent<'div'> = styled.div`
  margin-left: 12px;

  @media ${Breakpoint.Mobile} {
    margin-left: 0;
  }
`;

export const ArtworksContainer: StyledComponent<'div'> = styled.div`
  padding: 24px 24px 0;
`;

export const ArtworkContainerWrapper: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledArtworkContainer: StyledComponent<typeof ArtworkContainer> = styled(ArtworkContainer)`
  margin-bottom: 24px;
`;

export const ArtworkContainerPrice: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
`;

export const ItemDetailsContainer: StyledComponent<'div'> = styled.div`
  border-top: 1px solid ${Color.Gray300};
  padding: 24px 0;
`;

export const ItemSummary: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;

  & + & {
    margin-top: 8px;
  }
`;

export const ItemSummaryDetails: StyledComponent<'div'> = styled.div`
  text-align: right;
  margin-left: 15px;
`;

export const StyledValidationBar: StyledComponent<typeof ValidationBar> = styled(ValidationBar)`
  margin-top: 24px;

  @media ${Breakpoint.SmallMobile} { 
    margin-top: 12px;
  }
`; 

export const FinalPriceContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 22px;
  border-top: 1px solid ${Color.Gray300};
`;

export const FinalPrice: StyledComponent<'div'> = styled.div``;

export const DetailsButton: StyledComponent<'button'> = styled.button`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${Color.Gray300};
`;

export const DetailsContainer: StyledComponent<'div'> = styled.div``;

export const DetailsWrapper: StyledComponent<'div'> = styled.div`
  border-top: 1px solid ${Color.Gray300};
  margin-bottom: 24px;
  display: grid;
  grid-template-columns: repeat(4, minmax(calc(25% - 40px), 1fr));
  gap: 20px;

  @media ${Breakpoint.Mobile} {
    grid-template-columns: repeat(3, minmax(calc(33% - 40px), 1fr));
  }

  @media ${Breakpoint.SmallMobile} {
    grid-template-columns: repeat(1, minmax(50%, 1fr));
    gap: 0;
  }
`;

export const DetailsBox: StyledComponent<'div'> = styled.div`
  width: 100%;
  margin-top: 40px;
`;

export const DetailsTitle: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  max-width: 196px;
  width: 100%;
  padding: 0 0 12px;
`;

export const DetailsContent: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  margin-top: 12px;
  max-width: 196px;
  width: 100%;
`;

export const MobileItemSummaryContainer: StyledComponent<'div'> = styled.div`
  background-color: ${Color.Gray100};
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
`;

export const MobileItemSummary: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-size: 12px;
  line-height: 16px;
  color: ${Color.Black};
  width: 100%;
  padding: 12px 0;

  a {
    color: ${Color.Black};
  }

  & + & {
    border-top: 1px solid ${Color.Gray300};
  }
`;
